<ngx-spinner type="ball-scale-multiple">
  <button mat-flat-button color="primary" class="mt-3" (click)="cancelLoading()">Abbrechen</button>
</ngx-spinner>

<app-public-header></app-public-header >
<div class="main-body">
    <router-outlet></router-outlet>
</div>
<app-public-footer></app-public-footer>
